<template>            
    <v-flex xs6 lg3 pl-1 pr-2>
        <v-card color="white" class="white--text">
            <v-card-text class="pa-0">
                <v-container class="pa-0">
                    <div class="layout row ma-0">
                        <div class="sm6 xs6 flex">
                            <div class="layout column ma-0 justify-center align-center fill-height">
                                <v-icon size="32px" :color="color">{{ icon }}</v-icon>
                            </div>
                        </div>
                        <div class="sm6 xs6 flex text-sm-center py-3" :class="color">
                            <span class="title">{{ subtitle }}</span>
                            <div class="caption"> {{ title }}</div>
                        </div>
                    </div>
                </v-container>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
export default {
	name: 'kpi',
	props: {
		icon: String,
		color: String,
		number: String,
		title: String,
		subtitle: String
	},

	data() {
		return {
			model: {}
		}
	},

	created() {}
}
</script>
